var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerminalHeaderSelectorArrowUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.45027 15H16.5505C16.6325 14.9998 16.7129 14.983 16.783 14.9515C16.8531 14.9199 16.9103 14.8747 16.9484 14.8208C16.9865 14.7669 17.0041 14.7064 16.9992 14.6456C16.9944 14.5849 16.9673 14.5262 16.9209 14.4761L12.8707 10.135C12.7029 9.955 12.2988 9.955 12.1305 10.135L8.08036 14.4761C8.03348 14.5261 8.00599 14.5848 8.00087 14.6456C7.99576 14.7065 8.01321 14.7672 8.05134 14.8212C8.08947 14.8752 8.14682 14.9204 8.21715 14.952C8.28748 14.9835 8.36811 15.0001 8.45027 15Z",
    fill: "#0066FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminalHeaderSelectorArrowUpIcon);
export default __webpack_public_path__ + "static/media/terminalHeaderSelectorArrowUpIcon.04e48c173b603cde5ebcb592b68d6a85.svg";
export { ForwardRef as ReactComponent };